import React, {Component} from 'react'
import FJApplyToAllButton from './FJApplyToAllButton'
import './FJTopToolbarApplyAll.less'

class FJTopToolbarApplyAll extends Component {

    render() {
        return [
            <i key={1} className='c-apply-all-divider' />,
            <div key={2} className='c-apply-all-divider-container'>
                <FJApplyToAllButton onClick={this.props.onClick} />
            </div>
        ];
    }
}

export default FJTopToolbarApplyAll;
